export default "__VITE_ASSET__DYqE_Hrx__"